<template>
  <div class="applyCouncil" :class="{lan_En : lan != 'zh'}">
    <div class="bg1"><img src="../../assets/home/cont4_bg1.jpg" alt=""></div>
    <div class="content1">
      <div class="cont_title gradient_text">{{ $t('applyCouncil.title') }}</div>
      <div class="cont_desc">{{ $t('applyCouncil.text') }}</div>
      <div class="cont_desc">{{ $t('applyCouncil.text1') }}</div>
      <div class="cont_desc">{{ $t('applyCouncil.text2') }}</div>
      <div class="cont_desc margin0">{{ $t('applyCouncil.text3') }}</div>
      <div class="cont_btns">
        <a target="_blank" href="https://t.me/dbccouncil" class="cont_btn">{{ $t('applyCouncil.seedetails1') }}</a>
        <a target="_blank" href="https://www.dbcwallet.io/#/council" class="cont_btn">{{ $t('applyCouncil.seedetails2') }}</a>
        <!-- <div class="cont_btn">理事会会议讨论组</div>
        <div class="cont_btn">查看理事会信息</div> -->
      </div>
    </div>
    <div class="content2">
      <p class="cont2_text1">{{ $t('applyCouncil.cont.title') }}</p>
      <div class="procedure_wiki">
        <p class="procedure_text1">{{ $t('applyCouncil.procedure1.title1') }}</p>
        <p class="procedure_text2">{{ $t('applyCouncil.procedure1.text1') }}<a class="procedure_text3" target="_blank" href="https://www.dbcwallet.io">www.dbcwallet.io</a>，{{ $t('applyCouncil.procedure1.text2') }}</p>
        <img class="procedure_img" v-show="lan == 'zh'"  src="../../assets/wiki/applyCouncil-1.png" alt="">
        <img class="procedure_img" v-show="lan != 'zh'" src="../../assets/wiki/applyCouncil-1-en.png" alt="">
        <p class="procedure_text2">{{ $t('applyCouncil.procedure1.text3') }}</p>
        <img class="procedure_img" v-show="lan == 'zh'"  src="../../assets/wiki/applyCouncil-2.png" alt="">
        <img class="procedure_img" v-show="lan != 'zh'" src="../../assets/wiki/applyCouncil-2-en.png" alt="">
        <p class="procedure_text2">{{ $t('applyCouncil.procedure1.text3_1') }}</p>
        <img class="procedure_img" v-show="lan == 'zh'"  src="../../assets/wiki/applyCouncil-3.png" alt="">
        <img class="procedure_img" v-show="lan != 'zh'" src="../../assets/wiki/applyCouncil-3-en.png" alt="">
        <p class="procedure_text2">{{ $t('applyCouncil.procedure1.text4') }}</p>
        <p class="procedure_text2">{{ $t('applyCouncil.procedure1.text5') }}</p>
        <p class="procedure_text2">{{ $t('applyCouncil.procedure1.text6') }}</p>
        <img class="procedure_img" v-show="lan == 'zh'"  src="../../assets/wiki/applyCouncil-3.png" alt="">
        <img class="procedure_img" v-show="lan != 'zh'" src="../../assets/wiki/applyCouncil-3-en.png" alt="">
        <p class="procedure_text2">{{ $t('applyCouncil.procedure1.text7') }}</p>
        <p class="procedure_text2">{{ $t('applyCouncil.procedure1.text8') }}</p>
      </div>
      <div class="procedure_wiki">
        <p class="procedure_text1">{{ $t('applyCouncil.procedure2.title1') }}</p>
        <!-- <p class="procedure_text2">{{ $t('applyCouncil.procedure1.text1') }} <a class="procedure_text3" target="_blank" href="https://www.dbcwallet.io">www.dbcwallet.io</a>，{{ $t('applyCouncil.procedure1.text2') }}</p> -->
        <p class="procedure_text2">{{ $t('applyCouncil.procedure2.text1') }}</p>
        <img class="procedure_img" v-show="lan == 'zh'"  src="../../assets/wiki/applyCouncil-4.png" alt="">
        <img class="procedure_img" v-show="lan != 'zh'" src="../../assets/wiki/applyCouncil-4-en.png" alt="">
        <p class="procedure_text2">{{ $t('applyCouncil.procedure2.text2') }}</p>
        <p class="procedure_text2">{{ $t('applyCouncil.procedure2.text3') }}</p>
        <img class="procedure_img" v-show="lan == 'zh'"  src="../../assets/wiki/applyCouncil-5.png" alt="">
        <img class="procedure_img" v-show="lan != 'zh'" src="../../assets/wiki/applyCouncil-5-en.png" alt="">
        <p class="procedure_text2">{{ $t('applyCouncil.procedure2.text4') }}</p>
      </div>
    </div>
  </div>
</template>


<script>
  // @ is an alias to /src
  import { defineComponent, ref, computed, watch, onMounted  } from "vue";
  import { useStore } from "vuex"
  export default defineComponent({
    name: 'applyCouncil',
    setup() {
      const store = useStore()
      let lan = computed(() =>  store.state.lan)
      watch(lan, (newvlaue, oldvalue) => {
        console.log(newvlaue, oldvalue, 'ssss');
      })
      onMounted(() => {

      });
      return {
        lan,
      };
    }
  })
</script>

<style lang="scss" scoped>
.applyCouncil {
  min-width: 1200px;
  margin: auto;
  font-style: normal;
  // font-family: "Noto Sans SC";
  width: 100%;
  overflow: hidden;
  position: relative;
  .bg1 {
    position: absolute;
    top: -500px;
    margin: auto;
    width: 1920px;
    height: 1690px;
    left: 50%;
    transform: translateX(-50%);
    img {
      width: 1920px;
      height: 1690px;
    }
  }
  .cont_title {
    font-size: 48px;
    font-weight: 500;
    text-align: center;
    line-height: normal;
    margin-bottom: 40px;
    letter-spacing: 1.6px;
  }
  .cont_desc {
    max-width: 1000px;
    font-size: 16px;
    color: #899AA9;
    font-weight: 400;
    line-height: 24px; 
    text-align: center;
    letter-spacing: 1px;
    margin-bottom: 24px;
    &.margin0 {
      margin-bottom: 0;
    }
    a {
      color: #899AA9;
      text-decoration: none;
    }
  }
  .content1 {
    position: relative;
    width: 1200px;
    margin: auto;
    display: flex;
    align-items: center;
    flex-direction: column;
    padding: 100px 0 80px;
    box-sizing: border-box;
    .cont_btns {
      width: 700px;
      display: flex;
      align-items: center;
    }
    .cont_btn {
      margin: auto;
      color: #FFF;
      cursor: pointer;
      font-size: 16px;
      font-weight: 500;
      margin-top: 40px;
      padding: 10px 60px;
      line-height: normal;
      transition: all .5s;
      text-decoration: none;
      border: 1px solid #FFF;
      &:hover {
        color: #10132F;
        background: #FFF;
      }
    }
  }
  .content2 {
    position: relative;
    width: 1200px;
    margin: auto;
    padding: 100px 0 160px;
    box-sizing: border-box;
    .cont2_text1 {
      color: #FFF;
      font-size: 48px;
      font-weight: 400;
      text-align: center;
      line-height: normal;
      letter-spacing: 1px;
    }
    .cont2_text2 {
      font-size: 16px;
      color: #899AA9;
      font-weight: 400;
      margin-top: 40px;
      line-height: 24px;
      text-align: center;
      letter-spacing: 1px;
    }
    
  }
}

.lan_En.applyCouncil {
  .content1 {
    .cont_btns {
      width: 1000px;
      justify-content: space-around;
    }
  }
}
</style>
